import React, { useState } from 'react';
import { useQuotations } from '../hooks/useQuotations';
import QuotationList from '../components/quotations/QuotationList';
import QuotationFormSimple from '../components/quotations/QuotationFormSimple';
import { CreateQuotationData } from '../types/quotation';
import Modal from '../components/common/Modal';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../contexts/LanguageContext';
import toast from 'react-hot-toast';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import ShareQuotationModal from '../components/quotations/ShareQuotationModal';
import { Quotation } from '../types/quotation';

const Quotations: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { createQuotation } = useQuotations();
  const { t } = useLanguage();
  const [toSend, setToSend] = useState<Quotation | null>(null);

  const handleCreateQuotation = async (data: CreateQuotationData, opts?: { send?: boolean }) => {
    try {
      const id = await createQuotation(data);
      setIsModalOpen(false);
      toast.success(t('common.messages.quotation.createSuccess'));
      // Mentés és küldés: a friss ajánlattal megnyitjuk a küldés ablakot (e-mail az ügyfélnek, megosztási linkkel)
      if (opts?.send && id) {
        const snap = await getDoc(doc(db, 'quotations', id));
        if (snap.exists()) setToSend({ id: snap.id, ...(snap.data() as any) } as Quotation);
      }
    } catch (error) {
      console.error('Error creating quotation:', error);
      toast.error(t('common.messages.quotation.createError'));
    }
  };

  return (
    <div className="space-y-4">
      <QuotationList onNewClick={() => setIsModalOpen(true)} />

      <QuotationFormSimple
        isOpen={isModalOpen}
        onSubmit={handleCreateQuotation}
        onCancel={() => setIsModalOpen(false)}
      />

      <ShareQuotationModal isOpen={!!toSend} onClose={() => setToSend(null)} quotation={toSend} />
    </div>
  );
};

export default Quotations; 